<!--
 * @Author: xing.huang
 * @Date: 2021-01-20 17:40:12
 * @LastEditTime: 2021-03-05 13:49:08
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\Organization\CalendarBase.vue
 * @
-->
<template>
    <div id='calendar-base'>
        <div style="width:100%;display:flex;">
            <span class="head-title" style="line-height:34px">日历维护</span>
            
            <div style="display: flex;justify-content: center;width:90%;" >
                <div class="date-picker-warp">
                    <i class="el-icon-my-left" style="margin: 5px 10px;cursor: pointer;" @click="changeMonth($event,1)"></i>
                    <el-date-picker v-model="activeMonth" @change="changeMonth($event,2)" class="month-select" :clearable="false" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月"></el-date-picker>
                    <i class="el-icon-my-right" style="margin: 5px 10px;cursor: pointer;" @click="changeMonth($event,3)"></i>
                </div>
            </div>
        </div>
        <el-button :style="W?{margin:'14px 0'}:{margin:'6px 0'}" type="primary" size='mini' @click="itemClick({},1)">批量操作</el-button>
        
        <div style="display:flex;flex-wrap: wrap;" class="calendar-box">
            <div v-for="(item,index) in copyList" :key='index' class="calendar-warp" :style="(index+1)%2==0?{marginRight:'0px'}:{}">
                <div class="calendar-title">{{item|parseMonth}}月</div>
                <code style="display:flex" class="warp-heard">
                    <div style="display:flex;"><span class="sub-text">周一</span></div>
                    <div style="display:flex;"><span class="sub-text">周二</span></div>
                    <div style="display:flex;"><span class="sub-text">周三</span></div>
                    <div style="display:flex;"><span class="sub-text">周四</span></div>
                    <div style="display:flex;"><span class="sub-text">周五</span></div>
                    <div style="display:flex;"><span class="sub-text" style="color:red">周六</span></div>
                    <div style="display:flex;border-right:none"><span class="sub-text" style="color:red">周日</span></div>
                </code>
                <code v-for="(sub,subIndex) in item" :key='subIndex' style="display:flex" class="warp-body">
                    <div v-for="(lastItem,lastIndex) in sub" :key="lastIndex" style="display:flex;" class="last-item" :style="computedSubStyle(subIndex,lastIndex,lastItem)">
                        <span :class="lastItem.isToDay?['sub-text','today-bg']:['sub-text']" @click="itemClick(lastItem,2)" > 
                            <code class="left-day">{{lastItem|parseDate}}</code> 
                            <code class="right-shift" v-if="lastItem.shiftName">{{lastItem.shiftName}}</code>
                        </span>
                        <img v-if="lastItem.isWorkDay" class="del-day" @click="delDay(lastItem)"  src='../../../static/img/del-hover.png'>
                    </div>
                </code>
            </div>
        </div>

        <!--编辑窗口开始-->
        <el-dialog class="working-dialog" custom-class="working-dialog-wrap" title="编辑节假日" @close="closeEditDialog" :visible.sync="editDialogVisible" :width="span==5?'45%':'68%'"
            center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="changeForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title">日期：</span>
                            <el-form-item class="value time-range" style="width:400px">
                                <el-date-picker :disabled="!addForm.isChangeAll" :clearable="false" :picker-options="{disabledDate(time) {return time.getTime() > new Date(addForm.endTime).getTime()},}"
                                    style="width: 130px; display: inline-block;" v-model="addForm.beginTime" type="date"
                                    placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                                <span style="margin:0 8px">至</span>
                                <el-date-picker :disabled="!addForm.isChangeAll" :clearable="false"
                                    style="width: 130px; display: inline-block;" v-model="addForm.endTime" type="date" :picker-options="{disabledDate(time) {return time.getTime() < new Date(addForm.beginTime).getTime()-24*60*60*1000},}"
                                    placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="addForm.isChangeAll" >
                    <span>工作日维护</span>
                    <el-checkbox-group v-model="addForm.weekDays" style="display:inline-block;">
                        <el-checkbox :label="1">星期一</el-checkbox>
                        <el-checkbox :label="2">星期二</el-checkbox>
                        <el-checkbox :label="3">星期三</el-checkbox>
                        <el-checkbox :label="4">星期四</el-checkbox>
                        <el-checkbox :label="5">星期五</el-checkbox>
                        <el-checkbox :label="6">星期六</el-checkbox>
                        <el-checkbox :label="7">星期天</el-checkbox>
                    </el-checkbox-group>
                </el-row>
                <el-row :gutter="20" style="margin-top:10px">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title" style="margin-left: -14px;width: 84px;">调整为：</span>
                            <el-form-item class="value" >
                                <el-select  size="small" v-model="addForm.isWorkDay"
                                    style="display:block">
                                    <el-option label="工作日" :value="true"></el-option>
                                    <el-option label="休息日" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20" v-if="addForm.isWorkDay">
                    <div >
                        <el-table ref="shifTable" :data="shiftList" stripe style="width: 100%" border :maxHeight="280">
                            <el-table-column width='30' fixed >
                                <template slot-scope="scope">
                                    <el-radio :label="scope.row.id" v-model="addForm.shiftId" ></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="shiftCode" label="班次编码"></el-table-column>
                            <el-table-column prop="shiftName" label="班次名称"></el-table-column>
                            <el-table-column prop="beginTime" label="上班时间"></el-table-column>
                            <el-table-column prop="endTime" label="下班时间"></el-table-column>
                            <el-table-column prop="workTime" label="工作时长">
                                <template slot-scope="scope">
                                    {{scope.row.workTime|parseHours}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="isDaysSpanned" label="是否跨日">
                                <template slot-scope="scope">
                                    {{scope.row.isDaysSpanned?'是':'否'}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateCalendar()">确 定</el-button>
                <el-button @click="closeEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!--编辑窗口结束-->
    </div>
</template>
<script>
export default {
    name: 'CalendarBase',
    props:{
        id:Number
    },
	data () {
        let that = this
        return {
            W:true,
            editDialogVisible:false,
            copyList:[],
            activeMonth:'2021-01',
            startMonth:'',
            endMonth:'',
            colors:['#19ccab','#FFBB37','#409EFF','#FE825F'],
            shiftIdList:[],
            addForm: {
                beginTime: '',
                endTime: '',
                isChangeAll:false,
                isWorkDay: false,
                shiftId:null,
                factoryModelId:null,
                weekDays:[],
            },
            factoryModelId:null,
            shiftList:[],
            rules: {
              
                
            },
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    mounted(){
        this.loadShiftConfig()
        this.init()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    methods:{

        init(id){
            if(id){
                this.factoryModelId = id
            }
            this.activeMonth = commonUtils.timestampToDate(new Date().getTime()).slice(0,7)
            this.changeMonth({},2)
        },
        changeMonth(ev,type){
            if(type==1){
                this.endMonth = this.startMonth
                
                this.startMonth = this.prev(this.activeMonth)
                this.activeMonth = this.startMonth
            }else if(type==2){
                this.startMonth = this.activeMonth
                this.endMonth = this.next(this.activeMonth)
            }else{
                this.startMonth = this.endMonth
                this.activeMonth = this.startMonth
                this.endMonth = this.next(this.endMonth)
            }
            this.loadDateInfo()
        },

        prev(activeMonth){
            let [year,month] = activeMonth.split('-')
            if(Number(month)==1){
                year = Number(year)-1
                month = 12
            }else{
                month = Number(month) - 1
            }
            log(year,month)
            return year + '-' + month
        },

        next(activeMonth){
            let [year,month] = activeMonth.split('-')
            if(Number(month)==12){
                year = Number(year)+1
                month = '01'
            }else{
                month = Number(month) + 1
            }
            return year + '-' + month
        },

        computedSubStyle(rowIndex,columnIndex,lastItem){
            let json = {
                cursor:'pointer',
                position:'relative'
            }
            if(rowIndex>4){
                json.borderBottom = 'none'
            }
            if((columnIndex+1)%7==0){
                json.borderRight = 'none'
            }

            
            if (columnIndex == 5 || columnIndex == 6) {
                json.color = 'red'
                
            }
            if(lastItem.isWorkDay){
                let index = this.shiftIdList.indexOf(lastItem.shiftId)
                let colorIndex = index%this.colors.length
                json.background = this.colors[colorIndex]
                json.color = '#fff'
            }
            
            return json
        },

        itemClick(item,type) {
            this.addForm.isChangeAll = false
            this.addForm.isWorkDay = true
            this.addForm.shiftId = null
            if(type==1){ //批量
                
                this.addForm.beginTime = this.dataList[0][0].calDate
                let last = this.dataList[1][this.dataList[1].length-1]
                this.addForm.endTime = last.calDate
                this.addForm.isChangeAll = true
                this.addForm.weekDays = []
            }else{
                if(!item.calDate){
                    return
                }
                this.addForm.beginTime = item.calDate
                this.addForm.endTime = item.calDate
                let weekDay = new Date(item.calDate).getDay()
                if(weekDay==0){
                    weekDay = 7
                }
                this.addForm.weekDays = [weekDay]
                this.addForm.isWorkDay = item.isWorkDay
                this.addForm.shiftId = item.shiftId
            }
            this.editDialogVisible = true
            this.shiftList = commonUtils.cloneObj(this.shiftList).filter(item=>item.id)
            
        },

        //加载班次列表
        loadShiftConfig() {
            this.$RequestUtil.get({
                url: '/api/workCalendarShift/listWorkCalendarShift',
                type: 'sync',
                params: {},
                success: (res) => {
                    if (res.code == 0) {
                        this.shiftList = res.data
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },


        parseData() {
            let toDay = commonUtils.timestampToDate(new Date().getTime(),true)
            let shiftIdList = []
            this.dataList.forEach((item, itemIndex) => {
                let index = item[0].dayOfWeek
                
                if (index == 0) {
                    index = 7
                }
                let json = { calDate: '' }
                let number = index - 1
                let arr = []
                for (let i = 0; i < number; i++) {
                    arr.push(json)
                }
                item = [...arr, ...item]
                let arr1 = [[], [], [], [], [], []]
                item.forEach((sub, subIndex) => {
                    if(sub.calDate==toDay){
                        sub.isToDay = true
                    }
                    
                    if(sub.shiftId&&!shiftIdList.includes(sub.shiftId)){
                        shiftIdList.push(sub.shiftId)
                    }
                    let len = Math.floor(subIndex / 7)
                    arr1[len].push(sub)
                })
                this.shiftIdList = shiftIdList
                this.$set(this.copyList, itemIndex, arr1)
            })
        },

        loadDateInfo: function () {
            this.$RequestUtil.get({
                url: '/api/workCalendarShift/getResourceCalendar',
                type: 'sync',
                params: {
                    beginTime:this.startMonth,
                    endTime:this.endMonth,
                    factoryModelId:this.factoryModelId||this.id,
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.dataList = res.data
                        this.parseData()
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        updateCalendar() {
            if (!this.addForm.shiftId&&this.addForm.isWorkDay) {
                this.$message.warning('班组不能为空请选择班组')
                return
            }
            this.addForm.factoryModelId = this.id
            this.$RequestUtil.post({
                url: '/api/workCalendarShift/updateResourceCalendar',
                type: 'sync',
                params:this.addForm,
                success: (res) => {
                    if (res.code == 0) {
                        this.$message.success('修改成功')
                        this.loadDateInfo()
                        this.closeEditDialog()
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        delDay(item){
            this.$confirm('是否删除当前日历', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.addForm.beginTime = item.calDate
                this.addForm.endTime = item.calDate
                let weekDay = new Date(item.calDate).getDay()
                if(weekDay==0){
                    weekDay = 7
                }
                this.addForm.weekDays = [weekDay]
                this.addForm.shiftId = item.shiftId
                this.addForm.isWorkDay = false
                this.addForm.factoryModelId = this.id
                this.$RequestUtil.post({
                        url: '/api/workCalendarShift/updateResourceCalendar',
                        type: 'sync',
                        params:this.addForm,
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                this.loadDateInfo()
                            } else {
                                this.$message.error(res.message || res.msg)
                            }
                        }
                    });
            })
        },

        closeEditDialog() {
            this.editDialogVisible = false
            this.addForm = {
                beginTime: '',
                endTime: '',
                isChangeAll:false,
                isWorkDay: false,
                shiftId:null,
                factoryModelId:null,
                weekDays:[],
            }
        },
    },
    filters:{
        parseMonth(item) {
            if (item && item[1] && item[1][0] && item[1][0].calDate) {
                return item[1][0].calDate.slice(5, 7)
            } else {
                return ''
            }
        },
        parseDate(lastItem) {
            if (lastItem && lastItem.calDate) {
                return lastItem.calDate.slice(8)
            } else {
                return ''
            }
        },
        parseHours(ev){
            if(ev){
                return (ev/(60*60)).toFixed(1) + 'h'
            }else{
                return ''
            }
        },
    }
}
</script>
<style scoped>
    .calendar-warp {
        margin: 60px 20px 0px 0px;
        width: 49%;
        border: 1px solid #ccc;
        text-align: center;
        box-sizing: border-box;
        border-radius: 10px 10px 0 0;
    }
    .calendar-title {
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        background: #e7f5ff;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #666666;
        border-radius: 10px 10px 0 0;
    }
    .warp-body div,.warp-heard div {
        width: 14.28%;
        justify-content: center;
        /* border: 1px solid #ccc; */
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }
    .calendar-box{
        /* margin-top: 14px; */
    }
    .today-bg{
        background-image: url("../../../static/img/day.png");
        background-position-x: 2px;
        background-position-y: bottom;
        background-repeat: no-repeat;
        background-size: 23px;
    }

    .sub-text {
        /* line-height: 50px; */
        border-right: none;
        border-top: none;
        text-align: center;
        font-size: 12px;
        height: 64px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .left-day{
        width: 100%;
        box-sizing: border-box;
        text-align: left;
        padding-left: 12px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
    }
    .right-shift{
        width: 100%;
        box-sizing: border-box;
        text-align: right;
        padding-right: 12px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Medium;
    }

    .addForm .value {
        display: inline-block;
        width: 220px;
    }

    .addForm .title {
        width: 70px;
        text-align: right;
        display: inline-block;
    }
    .del-day{
        width: 18px;
        height: 19px;
        cursor: pointer;
        display: none;
        position: absolute;
        top: 0;
        right: 0;
    }
    .last-item:hover .del-day{
        display: block;
    }

    @media screen and (min-width:1200px) and (max-width: 1899px){
        .calendar-warp{
            width: 48.5%;
            margin: 10px 20px 0px 0px;
        }
        .sub-text {
            height: 50px;
        }
    }
</style>
<style>
.time-range .el-form-item__content {
    width: 400px;
}
@media screen and (max-width: 1600px) and (min-width:1280px){
    #calendar-base .el-date-editor.el-input, #calendar-base .el-date-editor.el-input__inner {
        width: 130px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Organization/CalendarBase.vue